import React, { useState, useEffect, useRef } from "react";
import "./tutor-registration.css";
import StudentImg from "../assets/student_img.png"

const StatCounter = ({ endValue, suffix = "" }) => {
  const [count, setCount] = useState(0);
  const countRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      {
        threshold: 0,
        rootMargin: "0px 0px -50px 0px" // Trigger when 50px from entering viewport
      }
    );

    if (countRef.current) {
      observer.observe(countRef.current);
    }

    return () => observer.disconnect();
  }, [endValue]);

  useEffect(() => {
    if (!isVisible) return;

    let start = 0;
    const end = parseFloat(endValue);
    if (isNaN(end)) {
      setCount(endValue);
      return;
    }

    const duration = 2000; // 2 seconds
    const startTime = performance.now();

    const animate = (currentTime) => {
      const elapsedTime = currentTime - startTime;
      const progress = Math.min(elapsedTime / duration, 1);

      // Cubic ease-out
      const easeProgress = 1 - Math.pow(1 - progress, 3);

      const currentCount = start + easeProgress * (end - start);

      if (endValue.toString().includes('.')) {
        setCount(currentCount.toFixed(1));
      } else {
        setCount(Math.floor(currentCount));
      }

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        setCount(endValue); // Ensure final value is exact
      }
    };

    requestAnimationFrame(animate);
  }, [isVisible, endValue]);

  return <span ref={countRef}>{count}{suffix}</span>;
};

const TutorRegistration = () => {
  return (
    <>
      <div className="tutor-wrapper">
        <div className="tutor-content">
          <div className="tutor-copy">
            <h1 className="tutor-heading">Welcome to <span style={{ color: "rgba(43, 147, 165, 1)" }}>HomeShiksha</span></h1>
            <p className="tutor-subheading">
              I personally welcome you to the HomeShiksha community. We have more than 1.1L+ students and 1.8L+ tutors on-board and with you joining I hope that the community grows further strong.
              <br />
              <br />
              My team is working hard to get you expert home tutors, online tutors or virtual tutors for academic, non academic and co-curricular courses.Check our free demo class at your door step and proceed with the tutor you like. Our mission is to make world class home-tutoring and 1 to 1 online tutoring accessible.
              <br />
              <br />
              Meanwhile if you have any grievances or suggestion for improvement, I am all ears. Let me know by replying to nitin.jain@homeshiksha.com ..
            </p>
            <div className="tutor-name">Nitin Jain (Director, HomeShiksha)</div>
          </div>
        </div>
        <div className="tutor-visual">
          {/* Replace src with your exported illustration from Figma */}
          <img
            src={StudentImg}
            alt="student-img"
          />
        </div>
      </div>
      <div className="tutor-stats-row">
        <div className="tutor-stat-card">
          <div className="tutor-stat-value">
            <StatCounter endValue="1.1" suffix="L+" />
          </div>
          <div className="tutor-stat-label">Students</div>
        </div>
        <div className="tutor-stat-card">
          <div className="tutor-stat-value">
            <StatCounter endValue="1.8" suffix="L+" />
          </div>
          <div className="tutor-stat-label">Tutors</div>
        </div>
        <div className="tutor-stat-card">
          <div className="tutor-stat-value">
            <StatCounter endValue="125" suffix="K+" />
          </div>
          <div className="tutor-stat-label">Social Media Community</div>
        </div>
        {/* <div className="tutor-stat-card">
          <div className="tutor-stat-value">
            <StatCounter endValue="2489" suffix="+" />
          </div>
          <div className="tutor-stat-label">Areas</div>
        </div> */}
      </div>
    </>
  );
};

export default TutorRegistration;
